// Confirmation modal shown before the matrix generate request when the canvas
// already holds objects the generated matrix would overlap: keep them or
// delete them first.
import ModalBody from '../ControlActionModalContent/components/ModalBody/ModalBody';
import Button from '../../Button/Button';
import { useTranslate } from '../../../hooks/context/useTranslate';
import { useModalKeyboard } from '../../../hooks/shortcuts/useModalKeyboard';

export interface MatrixOverlapModalContentProps {
  onKeep: () => void;
  onClear: () => void;
  onCancel: () => void;
}

const MatrixOverlapModalContent = ({
  onKeep,
  onClear,
  onCancel,
}: MatrixOverlapModalContentProps) => {
  const { t } = useTranslate();

  // Enter defaults to the non-destructive choice; Escape backs out to the
  // matrix dialog without generating.
  useModalKeyboard({ onEnter: onKeep, onEscape: onCancel });

  return (
    <ModalBody
      header={t('warning')}
      text={t('layoutEditor.matrixOverlapText')}
      className="matrix-overlap-modal"
      buttons={
        <>
          <Button color="primary" onClick={onKeep}>
            {t('layoutEditor.matrixOverlapKeep')}
          </Button>
          <Button color="light" fill="solid" onClick={onClear}>
            {t('layoutEditor.matrixOverlapClear')}
          </Button>
        </>
      }
    />
  );
};

export default MatrixOverlapModalContent;
